<template>
  <modal :show="show" @close="close">
    <v-flex class="ma-1" slot="title">Potwierdź zablokowanie karty</v-flex>

    <div>
      <v-layout column>
        <v-flex xs12>
          <w-schema :model="$schema.deactivate">
            <v-checkbox label="Blokada bezterminowa (deaktywacja)" />
          </w-schema>
        </v-flex>
      </v-layout>

      <v-layout v-if="!$schema.deactivate.$model" column>
        <v-flex xs12>
          <datepicker :schema="$schema.blockEndDate" />
        </v-flex>
      </v-layout>
    </div>

    <v-layout slot="actions">
      <v-spacer />

      <v-btn color="error" flat @click="close">Anuluj</v-btn>

      <v-btn color="success" flat @click="save">Zablokuj</v-btn>
    </v-layout>
  </modal>
</template>

<script>
import {
  CardExpirationType,
  CardExpirationTypeTranslation,
  CardState,
  CardStateTranslation
} from '@witkac/kartamiejska-shared';
import { schemaMixin, WSchema } from '@witkac/vuetify-components';

import Modal from '@/components/material/Modal';
import { manageMixin } from '@/mixins/manage';
import { notificationsMixin } from '@/mixins/notifications';
import schema from '@/schemas/cardBlock.schema';

function emptyData() {
  return {
    deactivate: false,
    blockEndDate: ''
  };
}

// @vuese
// Modal blokowania karty klienta
// @group Client-Profile
export default {
  schema,
  mixins: [manageMixin(undefined, {}, emptyData), notificationsMixin],
  props: {
    cardId: {
      type: Number,
      required: false
    }
  },
  methods: {
    // @vuese
    // Emituje event do zapisu danych
    add() {
      this.$emit('save', { ...this.model, cardId: this.cardId });
    }
  },
  components: { WSchema, Modal }
};
</script>
